import { withPageContainerStyles } from '@/common/components/page-layout';
import { cn } from '@/shadcn-ui/utils';

interface CatalogContentContainerProps {
  children: React.ReactNode;
  className?: string;
}

export default function CatalogContentContainer({
  children,
  className,
}: CatalogContentContainerProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center rounded-t-2xl bg-flexcar-neutral85',
        className
      )}
    >
      <div className={withPageContainerStyles('max-w-[1440px] py-6')}>{children}</div>
    </div>
  );
}
